const constructPayloadSubmit = (data) => {
  return {
    servicePriceId: data.servicePriceId || null,
    kodeDokumen: data?.kodeDokumen || null,
    mainDealer: data?.mainDealer?.value,
    detailCabang: data?.kodeCabang?.map((item) => ({
      id: item?.id || null,
      kodeCabang: item.value,
      servicePriceCabangId: item?.servicePriceCabangId || null,
    })),
    kodeCabang: data?.selectedCabang?.value,
    tanggalBerlaku: data?.tanggalBerlaku,
    keterangan: data?.keterangan,
    status: "ACTIVE",
    detailPrice: data?.dataDetail?.map((item) => ({
      id: item?.id || null,
      detailId: item?.detailId || null,
      kodeJasa: item?.kodeJasa,
      kodeVarian: item?.kodeVarian,
      hargaJasa: Number(item.harga),
    })),
  };
};

const validateRow = (row) => {
  return {
    kodeJasa: row?.kodeJasa !== null ? null : "Field wajib diisi.",
    namaJasa: row?.namaJasa !== null ? null : "Field wajib diisi.",
    serviceCategory:
      row?.serviceCategory !== null ? null : "Field wajib diisi.",
    kodeVarian: row?.kodeVarian !== null ? null : "Field wajib diisi.",
    namaVarian: row?.namaVarian !== null ? null : "Field wajib diisi.",
    harga: row?.harga !== null ? null : "Field wajib diisi.",
  };
};

const constructgetDetailData = (data, selectedMd) => {
  return {
    ...data,
    mainDealer: selectedMd,
    kodeCabang: selectedMd?.kodeCabang?.filter((item) =>
      data.cabangBerlaku?.includes(item.value)
    ),
    dataDetail: data?.dataDetail.map((item) => ({
      ...item,
      isSaved: true,
    })),
  };
};

export const getJasaDDL = (item, type) => {
  const key = type === "nama" ? "namaJasa" : "kodeJasa";
  return {
    label: item?.[key],
    value: item?.[key],
    kodeJasa: item.kodeJasa,
    namaJasa: item.namaJasa,
    kodeVarian: item.kodeVarian,
    namaVarian: item.namaVarian,
    serviceCategory: item.serviceCategory,
    serviceId: item.serviceId,
  };
};

function validateHargaJasaData(data) {
  const errors = {};
  let invalidDetail = false;

  const isEmpty = (value) =>
    value === null || value === undefined || value === "";

  errors.mainDealer =
    !data.mainDealer || data.mainDealer?.length === 0
      ? "Field wajib diisi"
      : null;
  errors.tanggalBerlaku = isEmpty(data.tanggalBerlaku)
    ? "Field wajib diisi"
    : null;

  if (!Array.isArray(data.detailCabang) || data.detailCabang.length === 0) {
    errors.detailCabang = "Field wajib diisi";
  } else {
    errors.detailCabang = null;
  }

  if (!Array.isArray(data.detailPrice) || data.detailPrice.length === 0) {
    errors.detailPrice = "Field wajib diisi";
  } else {
    const invalid = data.detailPrice.find(
      (item) =>
        !item.kodeJasa ||
        !item.kodeVarian ||
        item.harga == null ||
        item.isSaved !== true
    );
    errors.detailPrice = invalid ? "Field wajib diisi" : null;
    if (invalid) invalidDetail = true;
  }

  // Check if all fields are valid (no message & no invalidDetail)
  const isValid =
    Object.values(errors).every((value) => value === null) && !invalidDetail;

  return { isValid, errors, invalidDetail };
}

const validateRowJasa = (index, name, value, data) => {
  return data.find(
    (item) => item?.[name] === data[index]?.[name] && item[name] === value
  );
};

const validateUploadJasa = (dataUpload, dataTable) => {
  const currDataJasa = dataTable?.map((item) => item.kodeJasa);
  return dataUpload?.find((item) => currDataJasa.includes(item.kodeJasa));
};

export default {
  constructPayloadSubmit,
  validateRow,
  constructgetDetailData,
  getJasaDDL,
  validateHargaJasaData,
  validateRowJasa,
  validateUploadJasa,
};
